<template>
	<div class="container-fluid bg-white">
		<contact-toolbar heading="Jobs"></contact-toolbar>

		<div class="row">
			<div :class="hasPermsForBoth ? 'col-md-6' : 'col-md-12'" v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Jobs')">

				<h3>Projects</h3>

				<table-list
					:records="$store.contact.Job"
					:fields="jobFields"
					record-name="Project"
					has-edit="/project/{?}/dashboard"
					:hide-record-count="true"
					edit-button-text="Open"
					id-field="slug">
				</table-list>

			</div>
			<div :class="hasPermsForBoth ? 'col-md-6' : 'col-md-12'" v-if="getUserRoleType() == 'Admin' || hasModulePermRead('Services')">

				<h3>Services</h3>

				<table-list
					:records="$store.contact.Service"
					:fields="jobFields"
					record-name="Service"
					has-edit="/Service/{?}/dashboard"
					:hide-record-count="true"
					edit-button-text="Open"
					id-field="slug">
				</table-list>

			</div>
		</div>
	</div>
</template>

<script>
import ContactToolbar from "./ContactToolbar"
import ContactMixins from "@/mixins/ContactMixins"
import TableList from "../../components/TableList"

export default {

	name: 'ContactJobs',
	components: {
		ContactToolbar,
		TableList
	},
	mixins:[ContactMixins],
	data() {
		return {
			jobFields: [
				{
					label: "Job #",
					key: "job_num"
				},
				{
					label: "Job Name",
					key: "job_name"
				}
			],
		}
	},
	computed: {
		hasPermsForBoth() {
			if (this.getUserRoleType() == 'Admin' || (hasModulePermRead('Services') && hasModulePermRead('Jobs')))
				return true
			else
				return false
		},
		filteredServices() {
			return []
		},
		filteredJobs() {
			return []
		}
	},
	methods: {
		fetchData() {
			let vm = this

			this.spinner(true)

			let promises = [
				this.fetchContact(this.$route.params.id,[
					{model: "Job", filters: [['archived',0]]},
					{model: "Service", filters: [['archived',0]]},
					{model:"ContactFile", fields:[]}
				])
			]

			Promise.all(promises).then(responses => {
				vm.spinner(false)
			})
		}
	},
	created() {
		if (!("Job" in this.$store.contact) || !("Service" in this.$store.contact) || this.$route.params.id != this.$store.contact.slug)
			this.fetchData()
	}

}
</script>

